
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.334 8.5L11.659 6 7.334 3.5v5zm9.633-6.525c.108.391.183.917.233 1.583.059.667.084 1.242.084 1.742l.05.7c0 1.825-.134 3.166-.367 4.025-.208.75-.692 1.233-1.442 1.441-.391.109-1.108.184-2.208.234a55.476 55.476 0 01-2.992.083L9 11.833c-3.491 0-5.666-.133-6.525-.367-.75-.208-1.233-.691-1.441-1.441C.925 9.633.85 9.108.8 8.442A20.05 20.05 0 01.717 6.7L.667 6c0-1.825.133-3.167.367-4.025.208-.75.691-1.233 1.441-1.442C2.867.425 3.584.35 4.684.3A55.542 55.542 0 017.675.217L9 .167c3.492 0 5.667.133 6.525.366.75.209 1.234.692 1.442 1.442z","fill":"red"}})])
          )
        }
      }
    